import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

export const TreasuryList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="coin_id" reference="coins" label="Coin">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="treasury_entity_id" reference="treasury_entities" label="Entity">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="amount" />
    </Datagrid>
  </List>
);

export const TreasuryEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <ReferenceInput source="coin_id" reference="coins">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput source="treasury_entity_id" reference="treasury_entities">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="amount" />
    </SimpleForm>
  </Edit>
);

export const TreasuryCreate = () => (
  <Create>
    <SimpleForm>
      <ReferenceInput source="coin_id" reference="coins">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput source="treasury_entity_id" reference="treasury_entities">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="amount" required />
    </SimpleForm>
  </Create>
);

export const TreasuryShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField source="coin_id" reference="coins" label="Coin">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="treasury_entity_id" reference="treasury_entities" label="Entity">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="amount" />
    </SimpleShowLayout>
  </Show>
);
